module.exports = __webpack_public_path__ + "img/mockup-desktop-donquicompte.39a08bfa.png";